
{{each data}}
<li>
    <a href="/article/articledetail?aid={{$value.id}}">
        <span><img src="{{$value.cover}}" alt=""></span>
        <p class="title">{{$value.title}}</p>
        <p class="desc">{{$value.create_time}}</p>
    </a>
</li>
{{/each}}